import dom from '../../../wrapper/DomWrapper';

export default (el) => dom.getElementHeight(el) || 0;
